var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-videoplayer-vss",attrs:{"id":`videoPlayerVss-${_vm.playlistId.split(':').join('-')}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }